<template>
  <div>
    <THeading
      tag="h3"
      :level="3"
      class="mb-6 justify-between flex-wrap"
    >
      <span>{{ t('closestKOACampgrounds') }}</span>

      <TButton
        variant="link"
        :to="campgroundSearchLink"
        target="_blank"
        class="whitespace-nowrap"
      >
        {{ t('viewAllCampgrounds') }}
      </TButton>
    </THeading>

    <Grid
      :max-results="campgroundsData?.Data?.length ?? quantity"
      :sm-cols="2"
      :lg-cols="3"
      :rows="1"
    >
      <template #default="{ getItemClass }">
        <CampgroundsCard
          v-for="(campground, index) in campgroundsData?.Data ?? []"
          :key="campground?.Id ?? index"
          :index="index"
          :campground="campground"
          :is-loading="status === 'pending'"
          :show-delivery="rvHasDelivery && (campground?.DistanceKm ?? 0) <= rvDeliveryMaxDistanceInKm"
          :class="getItemClass(index)"
        />
      </template>
    </Grid>
  </div>
</template>

<script setup lang="ts">
import { ROUTE_BASE_NAME } from '~/constants'

const props = withDefaults(defineProps<{
  viewAllLink?: string
  quantity?: number
}>(), {
  quantity: 3,
})

const { locale, t } = useI18n()
const localePath = useLocalePath()

const {
  rvLocation,
  rvHasDelivery,
  rvDeliveryMaxDistanceInKm,
} = useRvDetails()

const { data: campgroundsData, status } = await useRentals('/api/campgrounds', {
  query: {
    PageSize: props.quantity,
    Latitude: rvLocation.value?.Latitude ?? undefined,
    Longitude: rvLocation.value?.Longitude ?? undefined,
    Language: lookupLocaleToLanguage(locale.value),
    Brand: 'KOA',
    // Limit to cross-border campgrounds ?
  },
  lazy: true,
})

const campgroundSearchLink = computed(() => {
  return props.viewAllLink || localePath({ name: ROUTE_BASE_NAME.campgrounds })
})
</script>

<i18n lang="json">
{
  "en": {
    "closestKOACampgrounds": "Nearby KOA campgrounds",
    "viewAllCampgrounds": "View campgrounds"
  },
  "fr": {
    "closestKOACampgrounds": "Campings KOA à proximité",
    "viewAllCampgrounds": "Voir campings"
  }
}
</i18n>
